// extracted by css-extract-rspack-plugin
export default {"root":"ConstructorPageMenu_root__r5OSU"};